import styled from "styled-components";

export const ActivityIndicatorContainer = styled.div`
  margin: -2.5px;
`;
